<template>
  <Teleport to="body">
    <transition name="dropdownx">
      <div
        v-if="dropdown.vsDropdownVisible"
        ref="options"
        class="con-vs-dropdown--menu vs-dropdown-menu"
        :class="[
          $attrs.class,
          {
            rightx: dropdown.vsDropRight || dropdown.rightx,
            notHeight,
          },
        ]"
        :style="[
          $attrs.style,
          {
            left: `${left}px`,
            top: `${top}px`,
          },
        ]"
        @mouseleave="handleMouseleave"
        @mouseenter="handleMouseenter"
      >
        <ul
          v-if="!dropdown.vsCustomContent"
          class="vs-component vs-dropdown--menu"
        >
          <slot />
        </ul>
        <div v-else class="vs-dropdown--custom vs-dropdown--menu">
          <slot />
        </div>
        <div
          ref="menuAfter"
          :class="[
            dropdown.vsDropRight
              ? 'vs-dropdown-right--menu--after'
              : 'vs-dropdown--menu--after',
          ]"
        />
      </div>
    </transition>
  </Teleport>
</template>

<script>
export default {
  name: "VsDropdownMenu",
  inheritAttrs: false,
  inject: ["vsDropdown"],
  computed: {
    dropdown() {
      return this.vsDropdown;
    },
  },
  data() {
    return {
      left: 0,
      top: 0,
      notHeight: false,
    };
  },
  mounted() {
    this.dropdown.registerMenu(this);
  },
  beforeUnmount() {
    this.dropdown.unregisterMenu(this);
  },
  methods: {
    updatePosition(trigger) {
      this.$nextTick(() => {
        const menu = this.$refs.options;
        if (!menu) return;
        const rect = trigger.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        if (rect.top + 300 >= window.innerHeight) {
          this.top = rect.top - menu.clientHeight - 7 + scrollTop;
          this.notHeight = true;
        } else {
          this.top = rect.top + trigger.clientHeight + scrollTop - 5;
          this.notHeight = false;
        }

        this.dropdown.rightx = false;
        if (rect.right < menu.clientWidth + 25) {
          this.left = menu.clientWidth + rect.left;
          this.dropdown.rightx = true;
        } else {
          this.left =
            rect.left +
            (this.dropdown.vsDropRight ? menu.clientWidth : trigger.clientWidth);
        }
        this.setDirection(trigger);
      });
    },
    setDirection(trigger) {
      const arrow = this.$refs.menuAfter;
      if (!arrow) return;
      if (trigger.getBoundingClientRect().top + 300 >= window.innerHeight) {
        arrow.style.bottom = "-5px";
        arrow.style.transform = "rotate(225deg)";
      } else {
        arrow.style.top = "10px";
      }
    },
    handleMouseenter() {
      if (!this.dropdown.vsTriggerClick) this.dropdown.setVisible(true);
    },
    handleMouseleave(event) {
      if (this.dropdown.vsTriggerClick) return;
      const related = event.relatedTarget;
      if (
        related &&
        this.dropdown.$refs.dropdown &&
        this.dropdown.$refs.dropdown.contains(related)
      ) {
        return;
      }
      this.dropdown.setVisible(false);
    },
  },
};
</script>
